import React from 'react';
import arcticLogo from '../../assets/logos/logo.png';
import coldtubLogo from '../../assets/logos/coldtub.png';
import sbLogo from '../../assets/logos/SpaBoyLogo.png';
import coldtubPalLogo from '../../assets/logos/coldtubpal.png';

const isColdTub = () => {
  const brand = localStorage.getItem('data-brand');
  if (brand) return brand === 'coldtub';
  return window.location.hostname.includes('mycoldtub');
};

interface LogoProps {
  height?: string;
  logo?: string;
}

const Logo: React.FC<LogoProps> = ({ height = '7rem', logo='arctic' }) => {
  const coldTub = isColdTub();
  const src = logo === 'spaboy'
    ? (coldTub ? coldtubPalLogo : sbLogo)
    : (coldTub ? coldtubLogo : arcticLogo);
  return (
    <img
      src={src}
      alt="Logo"
      style={{ height }}
    />
  );
};

export default Logo;